import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs';

import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormModule } from 'src/app/pages/shared/base';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';

@Component({
  selector: 'app-user-mobiles',
  templateUrl: './user-mobiles.component.html',
  imports: [BaseFormModule],
})
// extends BaseFormPageComponent
export class UserMobilesComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties
  @Input() index: number;
  @Input() isEdit: boolean;
  @Input() model: any;
  @Input() showAddOptionBtn: boolean = false;
  @Input() showDeleteOptionBtn: boolean = true;

  @Output('form') output_form = new EventEmitter<FormGroup>();
  @Output('removeMobile') output_removeMobile = new EventEmitter<any>();
  @Output('mobile') output_mobile = new EventEmitter<string>();
  @Output('addOption') output_addOption = new EventEmitter<any>();

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    this.initForm();
    this.detectChangeForm();
  }

  initForm() {
    this.form = new FormGroup({
      mobile: new FormControl('', [Validators.required]),
    });
  }

  onRemoveMobile(i) {
    this.output_removeMobile.emit(i);
  }

  emitAddOption() {
    this.output_addOption.emit();
  }

  emitForm() {
    this.output_form.emit(this.form);
  }

  emitMobile() {
    this.output_mobile.emit(this.model);
  }

  detectChangeForm() {
    try {
      this.form.valueChanges
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((event) => {
          this.emitForm();
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onEnterPressed(event: any) {
    event.preventDefault();
    this.emitAddOption();
  }
}
